import { render, staticRenderFns } from "./CategoryListView.vue?vue&type=template&id=39d70274&scoped=true"
import script from "./CategoryListView.vue?vue&type=script&lang=js"
export * from "./CategoryListView.vue?vue&type=script&lang=js"
import style0 from "./CategoryListView.vue?vue&type=style&index=0&id=39d70274&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d70274",
  null
  
)

export default component.exports